import { ChevronRight } from 'lucide-react'
import type { ReactNode } from 'react'
import { CollapsibleTrigger } from '@/components/ui/collapsible'
import { cn } from '@/lib/utils'

interface CollapsibleSectionHeaderProps {
  icon: ReactNode
  title: string
  count?: string | number | ReactNode
  isOpen: boolean
  rightSlot?: ReactNode
}

export function CollapsibleSectionHeader({
  icon,
  title,
  count,
  isOpen,
  rightSlot,
}: CollapsibleSectionHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <CollapsibleTrigger className="group flex items-center gap-1.5 flex-1 hover:bg-accent rounded-md h-8 px-2 -ml-2 cursor-pointer transition-colors">
        <ChevronRight
          className={cn(
            'size-4 text-muted-foreground group-hover:text-accent-foreground transition-all flex-shrink-0',
            isOpen && 'rotate-90',
          )}
        />
        <span className="text-muted-foreground group-hover:text-accent-foreground flex-shrink-0 transition-colors">{icon}</span>
        <h3 className="text-sm font-medium text-foreground group-hover:text-accent-foreground select-none transition-colors">
          {title}
        </h3>
        {count !== undefined && (
          <span className="text-sm text-muted-foreground group-hover:text-accent-foreground select-none transition-colors">{count}</span>
        )}
      </CollapsibleTrigger>
      {rightSlot}
    </div>
  )
}
